import React from 'react';

const Gallery = () => {
  return (
    <>
      {/* Khosikhadi Gallery Section - Dark background */}
      <section id="mmatlala" className="py-32" style={{background: '#1A1A1A'}}>
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-light text-center tracking-wide mb-12 text-white">KHOSIKHADI MMATLALA WA MUDAU</h2>
          <div className="grid grid-cols-3 gap-4 mt-8" data-aos="fade-up">
            {/* Left image */}
            <div className="overflow-hidden">
              <img 
                src="/images/image00012.jpeg" 
                alt="Khosikhadi Mmatlala Wa Motau" 
                className="w-full h-96 object-cover"
              />
            </div>
            {/* Center image (taller) */}
            <div className="overflow-hidden">
              <img 
                src="/images/image00013.jpeg" 
                alt="Khosikhadi Mmatlala Wa Motau" 
                className="w-full h-112 object-cover mt-8"
              />
            </div>
            {/* Right image */}
            <div className="overflow-hidden">
              <img 
                src="/images/image00014.jpeg" 
                alt="Khosikhadi Mmatlala Wa Motau" 
                className="w-full h-96 object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Storyteller Gallery Section - Gold/brown gradient background */}
      <section id="storyteller" className="py-32" style={{background: 'linear-gradient(to right, #8B6C42, #33280F)'}}>
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-light text-center tracking-wide mb-12 text-white">STORYTELLER</h2>
          <div className="grid grid-cols-3 gap-4 mt-8" data-aos="fade-up">
            {/* Left image */}
            <div className="overflow-hidden">
              <img 
                src="/images/image00019.jpeg" 
                alt="Khosikhadi as a storyteller" 
                className="w-full h-96 object-cover"
              />
            </div>
            {/* Center image (taller) */}
            <div className="overflow-hidden">
              <img 
                src="/images/image00020.jpeg" 
                alt="Khosikhadi as a storyteller" 
                className="w-full h-112 object-cover mt-8"
              />
            </div>
            {/* Right image */}
            <div className="overflow-hidden">
              <img 
                src="/images/image00021.jpeg" 
                alt="Khosikhadi as a storyteller" 
                className="w-full h-96 object-cover"
              />
            </div>
          </div>
          {/* Instagram Reel Link */}
          <div className="mt-12 text-center" data-aos="fade-up" data-aos-delay="300">
            <a 
              href="https://www.instagram.com/reel/C-4fPXIt9zD/?igsh=dzI3YnlvOWp0cnln" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group inline-flex items-center space-x-3 bg-white bg-opacity-10 hover:bg-opacity-20 px-8 py-4 rounded-full transition-all duration-300"
            >
              <i className="fab fa-instagram text-2xl text-white"></i>
              <span className="text-white tracking-wide">WATCH STORYTELLING REEL</span>
              <i className="fas fa-arrow-right text-white transform group-hover:translate-x-2 transition-transform duration-300"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Poet Gallery Section - Blue gradient background */}
      <section id="poet" className="py-32" style={{background: 'linear-gradient(to right, #40E0D0, #0000CD)'}}>
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-light text-center tracking-wide mb-12 text-white">POET</h2>
          <div className="grid grid-cols-3 gap-4 mt-8" data-aos="fade-up">
            {/* Left image */}
            <div className="overflow-hidden">
              <img 
                src="/images/image00023.jpeg" 
                alt="Khosikhadi as a poet" 
                className="w-full h-96 object-cover"
              />
            </div>
            {/* Center image (taller) */}
            <div className="overflow-hidden">
              <img 
                src="/images/image00024.jpeg" 
                alt="Khosikhadi as a poet" 
                className="w-full h-112 object-cover mt-8"
              />
            </div>
            {/* Right image */}
            <div className="overflow-hidden">
              <img 
                src="/images/image00023.jpeg" 
                alt="Khosikhadi as a poet" 
                className="w-full h-96 object-cover"
              />
            </div>
          </div>
          {/* Instagram Reel Link */}
          <div className="mt-12 text-center" data-aos="fade-up" data-aos-delay="300">
            <a 
              href="https://www.instagram.com/reel/DAVRtQftKLZ/?igsh=ZHRyNTFvNmZleHQ=" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-white rounded-full group hover:bg-white hover:bg-opacity-10 transition-all duration-300"
            >
              <div className="flex items-center space-x-3">
                <i className="fab fa-instagram text-2xl text-white"></i>
                <span className="text-white font-light tracking-wide">EXPERIENCE THE POETRY</span>
                <i className="fas fa-chevron-right text-white transform group-hover:translate-x-1 transition-transform duration-300"></i>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Model Gallery Section */}
      <section id="model" className="py-32" style={{background: 'linear-gradient(to right, #363636, #1A1A1A)'}}>
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-light text-center tracking-wide mb-12 text-white">MODEL</h2>
          <div className="grid grid-cols-3 gap-4 mt-8" data-aos="fade-up">
            {/* Left column - stacked images */}
            <div className="space-y-4">
              <div className="overflow-hidden">
                <img 
                  src="/images/image00026.jpeg" 
                  alt="Khosikhadi as a model" 
                  className="w-full h-64 object-contain"
                />
              </div>
              <div className="overflow-hidden">
                <img 
                  src="/images/image00027.jpeg" 
                  alt="Khosikhadi as a model" 
                  className="w-full h-64 object-contain"
                />
              </div>
              <div className="overflow-hidden">
                <img 
                  src="/images/image00028.jpeg" 
                  alt="Khosikhadi as a model" 
                  className="w-full h-64 object-contain"
                />
              </div>
            </div>
            {/* Center column - featured taller image */}
            <div className="overflow-hidden">
              <img 
                src="/images/image00029.jpeg" 
                alt="Khosikhadi as a model" 
                className="w-full h-112 object-contain mt-8"
              />
            </div>
            {/* Right column - stacked images */}
            <div className="space-y-4">
              <div className="overflow-hidden">
                <img 
                  src="/images/image00030.jpeg" 
                  alt="Khosikhadi as a model" 
                  className="w-full h-64 object-contain"
                />
              </div>
              <div className="overflow-hidden">
                <img 
                  src="/images/image00031.jpeg" 
                  alt="Khosikhadi as a model" 
                  className="w-full h-64 object-contain"
                />
              </div>
              <div className="overflow-hidden">
                <img 
                  src="/images/image00032.jpeg" 
                  alt="Khosikhadi as a model" 
                  className="w-full h-64 object-contain"
                />
              </div>
            </div>
          </div>
          {/* Instagram Profile Link */}
          <div className="mt-12 text-center" data-aos="fade-up" data-aos-delay="300">
            <a 
              href="https://www.instagram.com/mmatlala.mudau?igsh=MXhxMGVvM3ZqbjdnZA%3D%3D&utm_source=qr" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block bg-white bg-opacity-10 px-6 py-4 rounded-lg shadow-lg transform hover:scale-105 transition-all duration-300"
            >
              <div className="flex items-center space-x-4">
                <i className="fab fa-instagram text-3xl text-white"></i>
                <div className="text-left">
                  <p className="text-white text-sm opacity-80 tracking-wide">FOLLOW ON INSTAGRAM</p>
                  <p className="text-white font-light text-lg">@mmatlala.mudau</p>
                </div>
                <i className="fas fa-long-arrow-alt-right text-white text-xl"></i>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Commercial Modelling: Romans Advert Section */}
      <section id="commercial-model" className="py-32" style={{background: 'linear-gradient(to right, #E53E3E, #C53030)'}}>
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-light text-center tracking-wide mb-12 text-white">COMMERCIAL MODELLING: ROMANS ADVERT</h2>
          <div className="grid grid-cols-3 gap-4 mt-8" data-aos="fade-up">
            {/* First image */}
            <div className="overflow-hidden">
              <img 
                src="/images/1.jpg" 
                alt="Romans Pizza commercial" 
                className="w-full h-96 object-cover"
              />
            </div>
            {/* Second image (taller) */}
            <div className="overflow-hidden">
              <img 
                src="/images/2.jpg" 
                alt="Romans Pizza commercial" 
                className="w-full h-112 object-cover mt-8"
              />
            </div>
            {/* Third image */}
            <div className="overflow-hidden">
              <img 
                src="/images/3.jpg" 
                alt="Romans Pizza commercial" 
                className="w-full h-96 object-cover"
              />
            </div>
          </div>
          {/* Instagram Reel Link */}
          <div className="mt-12 text-center" data-aos="fade-up" data-aos-delay="300">
            <a 
              href="https://www.instagram.com/p/Cgc1vKmtX_A/?img_index=1&igsh=MXB4dzMwbWJ5bDRhaw==" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-4 bg-white bg-opacity-20 rounded-lg hover:bg-opacity-30 transition-all duration-300 group"
            >
              <div className="flex items-center space-x-4">
                <i className="fab fa-instagram text-2xl text-white"></i>
                <span className="text-white font-light tracking-wide">WATCH ROMANS PIZZA COMMERCIAL</span>
                <i className="fas fa-external-link-alt text-white group-hover:translate-x-1 transition-transform duration-300"></i>
              </div>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Gallery;